export default __webpack_public_path__ + "static/media/loc_img_4.42c64d24.jpg";